import React from 'react'
import styles from './IconImage.module.scss'

export default function IconImage() {
    return <div className={styles.root} />
}
